import AirbrakeClient from 'airbrake-js';
import Vue from 'vue';
import TOC from '@/views/toc.json';
import { SCORM } from 'pipwerks-scorm-api-wrapper';
import BTBConfig from '@/btb-conf.json';
import Meta from '@/metadata.json';
const airbrake = new AirbrakeClient({
  projectId: process.env.VUE_APP_AIRBRAKE_PROJECT,
  projectKey: process.env.VUE_APP_AIRBRAKE_KEY
});
const filteredEnviroments : string[] = ["development", "test"];
const filteredSeverities : string[] = ["debug", "info"];
const version: string = ` B${BTBConfig.builderInfo.version}-P${BTBConfig.playerInfo.version}-C${BTBConfig.courseInfo.version}`;
const scormInfo = {version: SCORM.version}

airbrake.addFilter(addContext)
airbrake.addFilter(filterEnviroments)

if(Vue.config.productionTip)
  Vue.config.errorHandler = vueErrorHandler

export default airbrake;

export function trace(error:string, component:string){
  airbrake.notify({
    error: error,
    context: { component: component, severity: inferScormLogsContext(error) }
  });
}

function addContext(notice: any){
  let metadata = Meta || {}
  notice.context.version = version
  notice.context.environment = process.env.NODE_ENV;
  notice.environment = {...BTBConfig, scormInfo,metadata}
  notice.params.course =  TOC.name ;
  return notice
}

function vueErrorHandler(err:any, vm:any, info:any) {
  airbrake.notify({
    error: err,
    context: { component: 'Vue' }
  });
}

function filterEnviroments(notice: any){
  if (filteredEnviroments.indexOf(notice.context.environment) > -1 || filteredSeverities.indexOf(notice.context.severity) > -1) {
    return null;
  }
  return notice
}

export function inferScormLogsContext(error:string){
  if(/Error/.test(error) || /failed/.test(error) )
    return 'error'

  if(/connection\.initialize called/.test(error))
    return 'debug'

  return 'info'
}